import { module } from 'angular';

import { AgentBookingVideoAllocated, default as agentBookingVideoAllocated } from './allocated/agent-booking-video-allocated.component.ajs';
import { AgentBookingVideoInprocess, default as agentBookingVideoInprocess } from './inprocess/agent-booking-video-inprocess.component.ajs';

export default module('contact.agent.contact-view.video.state', [])
  .component(agentBookingVideoAllocated, new AgentBookingVideoAllocated())
  .component(agentBookingVideoInprocess, new AgentBookingVideoInprocess()).name;
